export var EV;
(function (EV) {
  let SessionStatus;
  (function (SessionStatus) {
    SessionStatus["OK"] = "OK";
    SessionStatus["OFFLINE"] = "OFFLINE";
    SessionStatus["DISCONNECT"] = "DISCONNECT";
    SessionStatus["OVERLOADED"] = "OVERLOADED";
  })(SessionStatus = EV.SessionStatus || (EV.SessionStatus = {}));
  let ComparisonStatus;
  (function (ComparisonStatus) {
    ComparisonStatus["UPLOADING"] = "UPLOADING";
    ComparisonStatus["STARTED"] = "STARTED";
    ComparisonStatus["DONE"] = "DONE";
    ComparisonStatus["FAILED"] = "FAILED";
  })(ComparisonStatus = EV.ComparisonStatus || (EV.ComparisonStatus = {}));
  let SegmentType;
  (function (SegmentType) {
    SegmentType["WORD"] = "WORD";
    SegmentType["SYLLABLE"] = "SYLLABLE";
    SegmentType["PHONEME"] = "PHONEME";
  })(SegmentType = EV.SegmentType || (EV.SegmentType = {}));
  let SegmentStatus;
  (function (SegmentStatus) {
    SegmentStatus["DELETION"] = "DELETION";
    SegmentStatus["INSERTION"] = "INSERTION";
    SegmentStatus["SUBSTITUTION"] = "SUBSTITUTION";
    SegmentStatus["OK"] = "OK";
  })(SegmentStatus = EV.SegmentStatus || (EV.SegmentStatus = {}));
  /**
   * @example
   * const evapi: EVAPI = await APIFactory.init(soundServerUrl)
   */
  let APIFactory = /*#__PURE__*/(() => {
    class APIFactory {
      // boilerplate code. The server must provide an implementation into window.evapiImpl
      static init(soundServerUrl, apiUrl) {
        if (this.instance) {
          return Promise.resolve(this.instance);
        }
        if (soundServerUrl.endsWith('/')) {
          soundServerUrl = soundServerUrl.replace(/\/+$/, '');
        }
        if (!apiUrl) {
          const majorVersion = this.version.replace(/\.\d+$/, '');
          apiUrl = `${soundServerUrl}/evapi/${majorVersion}/evapi.impl.js`;
        }
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.setAttribute('src', apiUrl);
          document.head.appendChild(script);
          script.addEventListener('load', () => {
            this.instance = new window.evapiImpl({
              soundServerUrl
            });
            resolve(this.instance);
          });
          script.addEventListener('error', () => reject('Could not load API implementation from server'));
        });
      }
    }
    APIFactory.version = '1.0.3';
    return APIFactory;
  })();
  EV.APIFactory = APIFactory;
})(EV || (EV = {}));